module.exports = __webpack_public_path__ + "img/pay_qrcode.f5b7da60.png";